import React, { useEffect } from "react";
import "./ManageTranslatedSWIs.scoped.scss";
import { loadTranslatedSWIs } from "store/manageSW/manageSWActions";
import { useDispatch } from "react-redux";
import useSelector from "store/useSelector";
import { ITranslatedSWI, SWTypes } from "interfaces/sw/SWInterfaces";
import SWTypeIconAI from "components/sw/search/SWTypeIconAI";
import SWTypeIcon from "components/sw/search/SWTypeIcon";
import linkOpen from "media/icons/dls/expand-1.svg"
import { Routes } from "components/routing/Routing";
import { Link } from "react-router-dom";

interface IMangaeTranslatedSWIs {
    swType: SWTypes
    swGuid: string,
    swVersion: number,
}

const ManageTranslatedSWIs: React.FC<IMangaeTranslatedSWIs> = ({ swType, swGuid, swVersion }) => {
    const dispatch = useDispatch();
    const {
        manageSW: {
            translatedSWIs
        },
    } = useSelector(store => store);
    useEffect(() => {
        dispatch(loadTranslatedSWIs({ swGuid, swVersion }));
    }, [dispatch, swGuid, swVersion]);

    return (
        <div>
            <div className="row header">
                <div className="cell Type">
                    Type
                </div>
                <div className="cell Language">
                    Language
                </div>
                <div className="cell SWName">
                    StandardWork Name
                </div>
                <div className="cell Guid">
                    Guid
                </div>
                <div className="cell LastPublished">
                    Last Published
                </div>
                <div className="cell View">
                    View
                </div>

            </div>
            <div className="list-body">
                {
                    translatedSWIs?.map((translatedSWI: ITranslatedSWI, ix: number) => (
                        <div className="row-value row" key={ix.toString()}>
                            <div className="cell Type">
                                {swType === SWTypes.TLMSWI && translatedSWI.isAutoTranslated ? <SWTypeIconAI /> : <SWTypeIcon type={swType} />}
                            </div>
                            <div className="cell Language">
                                {translatedSWI.language}
                            </div>
                            <div className="cell SWName">
                                {translatedSWI.title}
                            </div>
                            <div className="cell Guid">
                                {translatedSWI.guid}
                            </div>
                            <div className="cell LastPublished">
                                <span>
                                    {translatedSWI.publishedDate}
                                    <br />
                                    (Version {translatedSWI.version})
                                </span>

                            </div>
                            <div className="cell View">
                                <Link
                                    target="_blank"
                                    className="rc-link"
                                    to={Routes.ViewStandardWork.replace(
                                        ":guid",
                                        translatedSWI.guid
                                    ).replace(
                                        ":version",
                                        translatedSWI.version.toString()
                                    )}
                                >
                                    <img src={linkOpen} className="icon-medium"/>
                                </Link>
                            </div>
                        </div>
                    ))
                }
            </div>

        </div>
    );
}

export default ManageTranslatedSWIs;
